import getVuePage from 'Utils/getVuePage';
import FeatureToggleService from "Services/FeatureToggleService";
import { AccessTypes } from "Constants";

const reviewVisits = async () => (await getVuePage('Billing/Review/VisitsForReview/VisitToReview')).default;
const reviewAddressUpdates = async () => (await getVuePage('Billing/Review/BillingReviewAddress')).default;
const addressUpdatesHistory = async () => (await getVuePage('Billing/Review/BillingReviewAddressHistory')).default;
const patientPayments = async () => (await getVuePage('Billing/Accounting/PatientPayments/PatientPayments')).default;
const addPatientPayment = async () => (await getVuePage('Billing/Accounting/PatientPayments/AddPatientPayment')).default;
const patientPaymentBatches = async () => (await getVuePage('Billing/PatientPayments/PatientPaymentBatches')).default;
const accountBalanceWriteOff = async () => (await getVuePage('Billing/Accounting/AccountBalanceWriteOff/AccountBalanceWriteOff')).default;
const patientStatementBatches = async () => (await getVuePage('Billing/PatientStatements/PatientStatementBatches')).default;
const claimsDashboardConfiguration = async () => (await getVuePage('Billing/ClaimsDashboard/ClaimsDashboardConfiguration')).default;
const claimsDashboardBase = async () => (await getVuePage('Billing/ClaimsDashboard/ClaimsDashboardBase')).default;

export const BillingRouteConfigs = [
    {
        name: 'BillingReviewVisits',
        path: '/billing/review/visits',
        component: reviewVisits
    },
    {
        name: 'BillingReviewAddress',
        path: '/billing/review/address/:billingPatientId?',
        component: reviewAddressUpdates
    },
    {
        name: 'BillingReviewAddressHistory',
        path: '/billing/review/addressHistory',
        component: addressUpdatesHistory
    },
    {
        name: 'patientsPayments',
        path: '/PatientsPayments',
        component: patientPayments,
    },
    {
        name: 'addPatientPayment',
        path: '/AddPatientPayment',
        component: addPatientPayment,
        props: (route) => ({
            batchId: route.query.batchId,
            patientId: route.query.patientId,
            isNavigatedFromSchedulerPage: route.query.isNavigatedFromSchedulerPage,
            dateOfService: route.query.dateOfService,
            therapistId: route.query.therapistId
        })
    },
    {
        name: 'BillingPatientPaymentBatches',
        path: '/billing/patientPayments/batches',
        component: patientPaymentBatches,
        beforeEnter: async (to, from, next) => {
            const allowed = await FeatureToggleService.checkFeatureToggle(AccessTypes.FeatureToggles.BillingPaymentBatchesModernization, false);
            allowed ? next() : next({ path: '/payments/paymentBatches' });
        }
    },
    {
        name: 'BillingPatientPaymentsAccountBalanceWriteOff',
        path: '/billing/patientPayments/accountBalanceWriteOff',
        component: accountBalanceWriteOff,
    },
    {
        name: 'BillingPatientStatementBatches',
        path: '/billing/patientStatements/batches',
        component: patientStatementBatches,
        beforeEnter: async (to, from, next) => {
            const allowed = await FeatureToggleService.checkFeatureToggle(AccessTypes.FeatureToggles.BillingPatientStatementRefactor2, false);
            allowed ? next() : next({ path: '/StatementBatchesStatus' });
        }
    },
    {
        name: 'BillingClaimsDashboardConfiguration',
        path: '/billing/claimsDashboard/configuration',
        component: claimsDashboardConfiguration
    },
    // Place top-level routes above dashboard to avoid route conflicts
    {
        name: 'BillingDashboard',
        path: '/billing/:page?/:query?',
        component: claimsDashboardBase,
        meta: {
            activeIcon: 'Billing'
        },
        props: (route) => {
            const page = route.params['page'];
            return {
                params: {
                    query: route.query,
                    page: page
                }
            };
        }
    }
]

export default BillingRouteConfigs;